import React, { useState } from 'react';
import { Form, Drawer, Button, Row, Col } from 'antd';
import { AvailabilityStateBadge } from 'works/legacy/components/availability-state-badge';
import { PrimaryButton } from '@common/components';
import { StaffingRequestSubmissionForm } from '@jobs/pages';
import { Store } from 'antd/lib/form/interface';
import { WorksProfileType } from '@clinician-profile/graphql';
import { StaffingRequestTypeType } from '@applicant-flow/types/staffing-request';

type StaffingRequestSubmissionDrawerProps = {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: Store) => void;
  selectedWorksProfile: WorksProfileType;
  doNotRehireComment?: string;
  staffingRequestType?: StaffingRequestTypeType;
};

export function StaffingRequestSubmissionDrawer({
  visible,
  onClose,
  onSubmit,
  selectedWorksProfile,
  doNotRehireComment,
  staffingRequestType,
}: StaffingRequestSubmissionDrawerProps) {
  const [formSubmitting, setFormSubmitting] = useState<boolean>(false);
  const [form] = Form.useForm();

  const onFormFinish = (values: Store): void => {
    setFormSubmitting(true);
    onClose();
    onSubmit(values);
  };

  const currentAssignments =
    selectedWorksProfile.currentStaffingRequestAssignments;

  return (
    <Drawer
      open={visible}
      onClose={onClose}
      width={600}
      title={`Add ${
        selectedWorksProfile && selectedWorksProfile.fullName
      }'s preferences for position`}
      footer={
        <Row gutter={[16, 0]}>
          <Col>
            <Button
              key="back"
              onClick={onClose}
              loading={formSubmitting}
              size="large"
            >
              {doNotRehireComment ? 'Back' : 'Cancel'}
            </Button>
          </Col>
          <Col>
            <PrimaryButton
              size="large"
              key="submit"
              onClick={form.submit}
              loading={formSubmitting}
            >
              Submit Candidate
            </PrimaryButton>
          </Col>
        </Row>
      }
    >
      {currentAssignments && currentAssignments.length > 0 && (
        <section className="available-state-container">
          <AvailabilityStateBadge
            doNotRehire={false}
            available={false}
            currentStaffingRequestAssignments={currentAssignments}
          />
        </section>
      )}

      <StaffingRequestSubmissionForm
        onFormFinish={onFormFinish}
        formSubmitting={formSubmitting}
        form={form}
        worksProfile={selectedWorksProfile}
        staffingRequestType={staffingRequestType}
      />

      <style jsx>{`
        .available-state-container {
          margin-bottom: 24px;
          line-height: 2;
        }
      `}</style>
    </Drawer>
  );
}
